
<template>
  <div class="menubar container-fluid" :class="{'menubar-android': isAndroid}" v-if="menulinks">
    <div class="col position-relative" v-for="link in menulinks" :key="link.id" @click="openLink(link)">
      <div style="text-align: center;" class="pt-2 ">
        <i class="menubar-item-icon" style="color:white;font-size:1.4rem" :class="link.icon_style"
           v-if="link.id !=  '83d6e8e2-d6ec-487c-9ed2-d5f966cb90f8'"></i>
        <div style="text-align: center; font-size: 1.4rem" class="" v-if="link.icon_fa">

          <font-awesome-icon style="color:#fff;" :icon="[link.icon_fa.type, link.icon_fa.name]"
                             class="menubar-item-icon"/>
        </div>
        <!--font-awesome-icon style="color:white;font-size:1.4rem" :icon="[link.icon_fa.type, link.icon_fa.name]"
                           class="menubar-item-icon"/-->
      </div>
      <div style="text-align: center" class="text " v-html="link.title[currentLanguage]" :style="{'color':'white'}"></div>
      <span v-if="link.target == '#/app/chat' && unreadTotal > 0"
            class="row position-absolute  translate-middle badge rounded-pill bg-primary d-md-none"
            style="top:20px;font-size:0.7rem; background: red !important; right:15px">
                {{ unreadTotal }}
              </span>
      <span v-if="link.target == '#/app/chat' && unreadTotal > 0"
            class="row position-absolute  translate-middle badge rounded-pill bg-primary d-none d-md-block"
            style="top:20px;font-size:0.7rem; background: red !important; right:45%">
                {{ unreadTotal }}
              </span>


      <span v-if="link.target == '#/app/posts' && unreadNews > 0"
            class="row position-absolute  translate-middle badge rounded-pill bg-primary d-md-none"
            style="top:20px;font-size:0.7rem; background: red !important; right:15px">
                {{ unreadNews }}
              </span>
      <span v-if="link.target == '#/app/posts' && unreadNews > 0"
            class="row position-absolute  translate-middle badge rounded-pill bg-primary d-none d-md-block"
            style="top:20px;font-size:0.7rem; background: red !important; right:45%">
                {{ unreadNews }}
              </span>
      <!-- <a

           class="menubar-item"
           style="position:relative;">

         <div class="text row" v-html="link.title['de']"
               :style="{'color':'white'}"></div>
         <div v-if="link.target == '#/app/posts' && unreadNews > 0"
               class="row position-absolute translate-middle badge rounded-pill bg-primary"
               style="top:15px; right:0px">
                 {{ unreadNews }}
               </div>
       </a>-->
    </div>

  </div>

</template>
<script>
import {mapState, mapActions, mapGetters} from "vuex";
import {alertController, isPlatform, modalController} from '@ionic/vue';
import router from '@/router';
const config = require('@/config');
export default {
  components: {},
  data() {
    return {
      menulinks: [],
      isIos: null,
      isAndroid: null,
    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('personalDB', ['unreadNews']),
  },
  methods: {
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions('menulinks', ['getMenuBarItems', 'isExternalLink']),
    ...mapActions('auth', ['GET_USERDATA','login']),
    ...mapActions('googleanalytics', ['trackWithLabel']),

    async prepareLinks() {
      this.menulinks = (await this.getMenuBarItems()).sort((a, b) => a.order - b.order);
      console.log('enhancedlink', this.menulinks)
    },
    async openLink(link) {
      if (link.redirect == '/app/chat') {
        this.goToChat()
      } else {
        this.trackWithLabel('menu_link:' + link.title.en)
        let external = await this.isExternalLink(link.redirect)
        if (external) {
          window.open(link.redirect, '_blank').focus();
        } else {
          router.push(link.redirect);
        }
      }
    },

    goToChat() {
      if (this.user && this.user.id) {
        if(localStorage.getItem('chatConsentGiven_' + this.user.id) || this.user.consent_given == 'OPT_IN'){
          this.$router.push('/app/chat/');
        }else{
          this.consentAlert()
        }

      } else {
        this.chatAlert()
      }
    },

    async consentAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Consent required',
            message: 'By using the chat portal, you are giving your consent to be visible to all AEC participants.<br>Should you wish to remove yourself from the chat portal please contact us at <a href="mailto:aec2025.abstracts@abstractserver.com">aec2025.abstracts@abstractserver.com</a>',
            buttons: [
              {
                text: 'I disagree',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'I agree',
                id: 'confirm-button',
                handler: () => {
                  localStorage.setItem('chatConsentGiven_' +this.user.id, true)
                  this.$router.push('/app/chat/');
                },
              },
            ],
          });
      return alert.present();
    },

    async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'You need to be logged in in order to access the chat.',
            message: 'Do you want to log in?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Confirm',
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },

    async presentNotAllowedAlert(text) {
      let buttons = [];
      if (text && text.length > 0) {
        buttons = [
          {
            text: 'Ok',
            id: 'confirm-button',
            handler: () => {
              console.log('Confirm Okay')
            },
          },
        ]
      } else {
        buttons = [
          {
            text: 'Ok',
            id: 'confirm-button',
            handler: () => {
              console.log('Confirm Okay')
            },
          },
          {
            text: 'Log In',
            id: 'confirm-button',
            handler: () => {
              this.login()
            },
          },
        ]
      }
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Content Restricted',
            message: text && text.length > 0 ? this.wordings[this.currentLanguage].SESSION_NO_ACCESS : 'Please log in to gain access.',
            buttons: buttons
          });
      return alert.present();
    },
    async loginByToken(tokenSent) {
      //check for token in path
      let token = tokenSent
      if (token) {

        localStorage.setItem("x-api-key", token);

        let userRequest = await store.dispatch("auth/GET_USERDATA");
        //this.user = userRequest.data;

        let tmpUser = userRequest.data;

        if (tmpUser) {

          await store.commit("auth/SET_USER", tmpUser);
          localStorage.setItem('user', JSON.stringify(tmpUser));
        }
        //splice the path
        window.history.pushState(
            {},
            document.title,
            '/'
        );
        router.push({name: 'Dashboard'});

      } else {
        router.next();
      }
      router.next();

    },
    async login2() {
      console.log("login")
      let self = this
      localStorage.setItem('lastPageBeforeLogin', location.hash);
      //let frontendKey = config.auth_key;
      if (isPlatform('ios') && typeof cordova != 'undefined') {
        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key + '?logout=true', '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line

        let redirect = (param) => {
          console.log('PARAM', param)
          if (param && param.indexOf('token=') != -1) {
            let token = param.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        }

        ref.addEventListener('loaderror', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
        ref.addEventListener('loadstart', function (event) {
          console.log('PARAM', event)
          /*ref.executeScript({code: "document.redirectLink = (document.getElementById('redirect').href);"}, ((link) => {
            redirect(link.toString());
          }));*/
          console.log('PARAM', event.url)
          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });


      } else if (isPlatform('android') && typeof cordova != 'undefined') {

        let ref = cordova.InAppBrowser.open("https://auth.documedias.com/application/" + config.auth_dev_key, '_blank', 'location=yes', 'clearcache=no', 'clearsessioncache=no'); // eslint-disable-line
        ref.addEventListener('loaderror', function (event) {

          if (event.url.indexOf('token=')) {
            let token = event.url.split('token=')[1];
            if (token) {
              self.loginByToken(token);
              this.loginAlertOpen = false;
              ref.close();
            }
          }
        });
      } else {
        console.log("essta")
        //window.location.href = "https://auth.documedias.com/application/" + config.auth_dev_key
        window.location.href = "https://auth.documedias.com/application/" + (process.env.NODE_ENV == 'production' ? config.auth_key : config.auth_dev_key) + '?logout=true'

      }

    },

  },
  async created() {
    this.isIos = isPlatform('ios')
    this.isAndroid = isPlatform('android')
    await this.prepareLinks();
  },

  mounted() {
  },
  beforeUnmount() {
  },

  watch: {
    updateFinished: async function (newVal) {
      if (newVal) {
        this.prepareLinks();
      }
    },
  },

};
</script>
<style lang="scss">
.menubar {
  position: relative;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 0 8px;
  background: rgba(31, 76, 148, 0.82);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);

  > .col {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    transition: background 0.2s ease;

    &:active {
      background: rgba(255, 255, 255, 0.12);
    }
  }
}

.menubar-android{
  margin-bottom: env(safe-area-inset-bottom);
}

.text {
  font-size: 12px;
  margin-top: -5px;
}

.icon {
  font-size: 26px;
}
</style>
